<template>
  <v-application v-if="access.inv_purchase_mark">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="purchase-mark"
          to="/inventory/purchase_mark"
          v-bind:num-pages="purchases_total"
          v-model="currentMarkPage"
          v-bind:headers="headers"
          @change-pagination="changePaginationMark"
          :loading_items_table_data="data_loading"
          v-bind:data="purchases"
          no-delete
          view
          showSearch
          invPurchaseMark
          :add_button_name="'add_mark'"
          v-bind:search_text="search_text"
          v-bind:getData="update_purchase_marks"
          v-bind:searchActivate="
            (state) => {
              search_text = state;
            }
          "
          v-bind:setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #top>
            <v-combobox
              v-model="supplier"
              label="Supplier"
              v-bind:items="all_suppliers_"
              hide-details
              item-text="supplier_name"
              class="mx-1"
            />
            <v-combobox
              v-model="store"
              label="Store"
              v-bind:items="stores"
              hide-details
              item-text="name"
              class="mx-1"
            />
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Purchases from "../../mixins/inventory/purchase";
import Suppliers from "../../mixins/inventory/supplier";
import Services from "../../mixins/services";
const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  }
);
export default {
  name: "InventoryPurchaseMark",
  mixins: [Purchases, Services, AllSuppliers],
  data: () => ({
    data: [],
    search_text: false,
    search: "",
  }),
  methods: {
    changePaginationMark(page) {
      // this.purchases_page = page;
      // this.$store.commit("purchaseOrder/updatePagination", page)
      this.$store.commit("purchaseMark/updatePagination", page);
      this.update_purchase_marks();
    },
    // changePaginationMark(page) {
    //   // this.purchases_page = page;
    //   // this.$store.commit("purchaseOrder/updatePagination", page)
    //   this.$store.commit("purchaseMark/updatePagination", page);
    //   this.update_purchase_marks();
    // },
  },
  computed: {
    currentMarkPage: {
      get() {
        return this.$store.state.purchaseMark.page;
      },
      set(val) {
        this.$store.commit("purchaseMark/updatePagination", val);
      },
    },
    headers() {
      let headers = [
        { text: this.$t("purchase_order"), value: "p_order", available: true },
        {
          text: this.$t("date"),
          value: "purchase_order_date",
          available: true,
        },
        { text: this.$t("supplier"), value: "supplier_name", available: true },
        { text: this.$t("store"), value: "service_name", available: true },
        // { text: this.$t("status"), value: "status" },
        {
          text: this.$t("last_date_pricing"),
          value: "last_pricing_date",
          available: true,
        },
        { text: this.$t("received"), value: "received", available: true },
        { text: this.$t("expected_on"), value: "expected_on", available: true },
        { text: this.$t("note"), value: "notes", width: 150, available: true },
      ];
      if (this.user_access && this.user_access.inv_purchase_orders_cost) {
        headers.push({
          text: this.$t("total"),
          value: "total",
          align: "right",
          available: true,
        });
      }
      return headers;
    },
  },
  mounted() {
    this.status = { value: "closed" };
  },
  watch: {
    store: {
      deep: true,
      handler() {
        this.$store.commit("setItemsService", this.store);
        this.update_purchase_marks();
      },
    },
    supplier: {
      deep: true,
      handler() {
        this.$store.commit("setSupplier", this.supplier);
        this.update_purchase_marks();
      },
    },
    status: {
      deep: true,
      handler() {
        this.update_purchase_marks();
      },
    },
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    this.access = this.$store.state.access;
    this.supplier = this.$store.state.supplier1;
    if (this.supplier && !this.supplier.supplier_name) {
      this.supplier.supplier_name = this.$t("all_suppliers");
    }
  },
};
</script>